import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@americanexpress/aqx-components';
import { isGCSMember, getCardMemberCards } from 'src/universal/redux/cardMemberInfo';
import { getAddSupCardData } from '../redux';
import {
  mapUrlWithDtmLinkQuery,
  sendDTMClickEvent
} from 'service_modules/models/dtm-tagging';
import styles from '../__styles__/addEmployeeCardCta.scss?modules';

const AddEmployeeCardCta = ({ shortName, addSupCardData, isGcsCM, userCards }) => {
  const ctaUrl = mapUrlWithDtmLinkQuery(addSupCardData?.url, addSupCardData?.dtm);

  if (!isGcsCM || !(userCards || []).find(card => card.shortName === shortName)) {
    return null;
  }

  const handleCtaClick = () => {
    sendDTMClickEvent(addSupCardData.dtm);
  };

  return (
    <Button
      Component="a"
      className={styles.addEmpCardCta}
      href={ctaUrl}
      onClick={handleCtaClick}
    >
      <p>{addSupCardData?.text}</p>
    </Button>
  );
};

const mapStateToProps = state => {
  return {
    isGcsCM: isGCSMember(state),
    userCards: getCardMemberCards(state),
    addSupCardData: getAddSupCardData(state)
  };
};

export default connect(mapStateToProps)(React.memo(AddEmployeeCardCta));
